// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --sq-brand: #e63b11;
  --sq-brand-strong: #c9320c;
  --sq-brand-stronger: #a82a0a;
  --sq-brand-soft: #fdeee9;
  --sq-navy: #01426a;
  --sq-navy-deep: #012a45;
  --sq-navy-darker: #011f33;
  --sq-sky: #77c5d5;
  --sq-bg: #f3f5f8;
  --sq-surface: #ffffff;
  --sq-surface-2: #f8fafc;
  --sq-surface-3: #eef2f6;
  --sq-border: #e1e7ee;
  --sq-border-strong: #c8d1dc;
  --sq-text: #10212f;
  --sq-text-2: #43546a;
  --sq-text-3: #5a6b80;
  --sq-good: #067647;
  --sq-good-bg: #ecfdf3;
  --sq-good-line: #abefc6;
  --sq-warn: #a85606;
  --sq-warn-bg: #fff8eb;
  --sq-warn-line: #fbd98a;
  --sq-bad: #b42318;
  --sq-bad-bg: #fef3f2;
  --sq-bad-line: #fecdca;
  --sq-info: #01426a;
  --sq-info-bg: #eef7fc;
  --sq-info-line: #b6def0;
  --sq-neutral: #43546a;
  --sq-neutral-bg: #f1f4f8;
  --sq-neutral-line: #dde4ec;
  --sq-cat-available: #45b854;
  --sq-cat-ready: #f08a24;
  --sq-cat-complete: #3a9bb0;
  --sq-cat-in-use: #e9c400;
  --sq-cat-error: #b91c1c;
  --sq-cat-out-of-order: #6c757d;
  --sq-cat-unknown: #adb5bd;
  --sq-font: "Inter Variable", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  --sq-mono: ui-monospace, SFMono-Regular, Menlo, Consolas, "Liberation Mono", monospace;
  --sq-radius-sm: 8px;
  --sq-radius: 12px;
  --sq-radius-lg: 16px;
  --sq-shadow-sm: 0 1px 2px rgba(16, 33, 47, 0.05);
  --sq-shadow: 0 1px 3px rgba(16, 33, 47, 0.06), 0 6px 16px -8px rgba(16, 33, 47, 0.1);
  --sq-shadow-lg: 0 12px 32px -8px rgba(16, 33, 47, 0.24);
  --sq-focus: 0 0 0 3px rgba(1, 66, 106, 0.28);
  --sq-sidebar-w: 256px;
  --sq-topbar-h: 56px;
  --sq-bottomnav-h: 60px;
  --sq-safe-bottom: env(safe-area-inset-bottom, 0px);
  --sq-page-x: clamp(0.875rem, 2.4vw, 1.75rem);
}

@media (max-width: 767px) {
  .sq-table.is-stacked td.sales-hide-phone {
    display: none;
  }
}
.sales-page-numbers {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  color: var(--sq-text-3);
}
@media (max-width: 767px) {
  .sales-page-numbers {
    display: none;
  }
}
.sales-page-numbers [aria-current=page] {
  --bs-btn-bg: var(--sq-navy);
  --bs-btn-color: #fff;
  --bs-btn-border-color: var(--sq-navy);
  --bs-btn-hover-bg: var(--sq-navy);
  --bs-btn-hover-color: #fff;
}

.MuiPaper-root.sales-drawer {
  width: 420px;
  max-width: 100%;
}
@media (max-width: 767px) {
  .MuiPaper-root.sales-drawer {
    width: 100%;
    max-height: calc(100dvh - 40px);
  }
}

.sales-drawer-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.75rem 0.75rem 0.75rem 1.25rem;
  border-bottom: 1px solid var(--sq-border);
}
.sales-drawer-head h2 {
  margin: 0;
  font-size: 1.0625rem;
  font-weight: 650;
}

.sales-drawer-body {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 1rem 1.25rem 1.25rem;
}`, "",{"version":3,"sources":["webpack://./src/styles/tokens.scss","webpack://./src/components/customerservice/customerservice.scss"],"names":[],"mappings":"AAOA;EAGE,mBAAA;EACA,0BAAA;EACA,4BAAA;EACA,wBAAA;EACA,kBAAA;EACA,uBAAA;EACA,yBAAA;EACA,iBAAA;EAGA,gBAAA;EACA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,oBAAA;EACA,2BAAA;EAGA,kBAAA;EACA,oBAAA;EACA,oBAAA;EAIA,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;EACA,wBAAA;EACA,0BAAA;EAGA,2BAAA;EACA,uBAAA;EACA,0BAAA;EACA,wBAAA;EACA,uBAAA;EACA,8BAAA;EACA,yBAAA;EAGA;uCAAA;EAEA,sFAAA;EAGA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,gDAAA;EACA,oFAAA;EACA,uDAAA;EACA,4CAAA;EAIA,qBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kDAAA;EACA,4CAAA;ACxBF;;AApDA;EACE;IACE,aAAA;EAuDF;AACF;AApDA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;AAsDF;AApDE;EANF;IAOI,aAAA;EAuDF;AACF;AArDE;EACE,2BAAA;EACA,oBAAA;EACA,qCAAA;EACA,iCAAA;EACA,0BAAA;AAuDJ;;AAnDA;EACE,YAAA;EACA,eAAA;AAsDF;AApDE;EAJF;IAKI,WAAA;IACA,+BAAA;EAuDF;AACF;;AApDA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,wCAAA;EACA,yCAAA;AAuDF;AArDE;EACE,SAAA;EACA,oBAAA;EACA,gBAAA;AAuDJ;;AAnDA;EACE,SAAA;EACA,aAAA;EACA,gBAAA;EACA,6BAAA;AAsDF","sourcesContent":["// Design tokens — the single source of truth for colour, type, space and depth.\n// Every component reads these CSS variables; nothing else should hard-code a hex.\n\n// Breakpoints (Sass only — media queries can't read CSS variables).\n$bp-phone: 767px; // Up to here: single column, stacked tables, bottom sheets.\n$bp-shell: 991px; // Up to here: top bar + bottom nav instead of the sidebar.\n\n:root {\n  // Brand. `--sq-brand` is the logo orange, used for accents and large marks.\n  // `--sq-brand-strong` carries white text at AA contrast (the logo orange is 4.2:1).\n  --sq-brand: #e63b11;\n  --sq-brand-strong: #c9320c;\n  --sq-brand-stronger: #a82a0a;\n  --sq-brand-soft: #fdeee9;\n  --sq-navy: #01426a;\n  --sq-navy-deep: #012a45;\n  --sq-navy-darker: #011f33;\n  --sq-sky: #77c5d5;\n\n  // Surfaces and lines.\n  --sq-bg: #f3f5f8;\n  --sq-surface: #ffffff;\n  --sq-surface-2: #f8fafc;\n  --sq-surface-3: #eef2f6;\n  --sq-border: #e1e7ee;\n  --sq-border-strong: #c8d1dc;\n\n  // Text.\n  --sq-text: #10212f;\n  --sq-text-2: #43546a;\n  --sq-text-3: #5a6b80;\n\n  // Status tones. Reserved for state — never decoration — and always paired\n  // with a label or icon so meaning never rests on colour alone.\n  --sq-good: #067647;\n  --sq-good-bg: #ecfdf3;\n  --sq-good-line: #abefc6;\n  --sq-warn: #a85606;\n  --sq-warn-bg: #fff8eb;\n  --sq-warn-line: #fbd98a;\n  --sq-bad: #b42318;\n  --sq-bad-bg: #fef3f2;\n  --sq-bad-line: #fecdca;\n  --sq-info: #01426a;\n  --sq-info-bg: #eef7fc;\n  --sq-info-line: #b6def0;\n  --sq-neutral: #43546a;\n  --sq-neutral-bg: #f1f4f8;\n  --sq-neutral-line: #dde4ec;\n\n  // Machine states on the Status page.\n  --sq-cat-available: #45b854;\n  --sq-cat-ready: #f08a24;\n  --sq-cat-complete: #3a9bb0;\n  --sq-cat-in-use: #e9c400;\n  --sq-cat-error: #b91c1c;\n  --sq-cat-out-of-order: #6c757d;\n  --sq-cat-unknown: #adb5bd;\n\n  // Type.\n  --sq-font: \"Inter Variable\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    \"Helvetica Neue\", Arial, sans-serif;\n  --sq-mono: ui-monospace, SFMono-Regular, Menlo, Consolas, \"Liberation Mono\", monospace;\n\n  // Shape and depth.\n  --sq-radius-sm: 8px;\n  --sq-radius: 12px;\n  --sq-radius-lg: 16px;\n  --sq-shadow-sm: 0 1px 2px rgba(16, 33, 47, 0.05);\n  --sq-shadow: 0 1px 3px rgba(16, 33, 47, 0.06), 0 6px 16px -8px rgba(16, 33, 47, 0.1);\n  --sq-shadow-lg: 0 12px 32px -8px rgba(16, 33, 47, 0.24);\n  --sq-focus: 0 0 0 3px rgba(1, 66, 106, 0.28);\n\n  // Shell. The bottom offset keeps content clear of the fixed nav and the\n  // iPhone home indicator.\n  --sq-sidebar-w: 256px;\n  --sq-topbar-h: 56px;\n  --sq-bottomnav-h: 60px;\n  --sq-safe-bottom: env(safe-area-inset-bottom, 0px);\n  --sq-page-x: clamp(0.875rem, 2.4vw, 1.75rem);\n}\n","@import \"../../styles/tokens.scss\";\n\n// Cards stay short on phones; the rest is one tap away in the details sheet.\n@media (max-width: $bp-phone) {\n  .sq-table.is-stacked td.sales-hide-phone {\n    display: none;\n  }\n}\n\n.sales-page-numbers {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  color: var(--sq-text-3);\n\n  @media (max-width: $bp-phone) {\n    display: none;\n  }\n\n  [aria-current=\"page\"] {\n    --bs-btn-bg: var(--sq-navy);\n    --bs-btn-color: #fff;\n    --bs-btn-border-color: var(--sq-navy);\n    --bs-btn-hover-bg: var(--sq-navy);\n    --bs-btn-hover-color: #fff;\n  }\n}\n\n.MuiPaper-root.sales-drawer {\n  width: 420px;\n  max-width: 100%;\n\n  @media (max-width: $bp-phone) {\n    width: 100%;\n    max-height: calc(100dvh - 40px);\n  }\n}\n\n.sales-drawer-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.75rem 0.75rem 0.75rem 1.25rem;\n  border-bottom: 1px solid var(--sq-border);\n\n  h2 {\n    margin: 0;\n    font-size: 1.0625rem;\n    font-weight: 650;\n  }\n}\n\n.sales-drawer-body {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 1rem 1.25rem 1.25rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
